import { useSelector } from "react-redux";
import { WarningOutlined } from "@ant-design/icons";
import { useTranslation } from 'react-i18next';

const BANNER_HEIGHT = 44; // Height of the banner in pixels

const PlanLimitBanner = () => {
    const { t } = useTranslation();
    const { userInfo } = useSelector((state) => state.user);
    const { limits } = useSelector((state) => state.plan);

    // Only show for admin users
    if (!userInfo?.isAdmin) {
        return null;
    }

    // Get current usage from userInfo.spaceInfo
    const currentSpacesCount = userInfo?.spaceInfo?.length || 0;
    const spacesLimit = limits?.spaces || 0;

    // Check if limit is reached (current >= limit)
    const isSpacesLimitReached = spacesLimit > 0 && currentSpacesCount >= spacesLimit;

    // Don't show banner if no limit is reached
    if (!isSpacesLimitReached) {
        return null;
    }

    return (
        <div
            className="plan-limit-banner"
            style={{
                position: "sticky",
                top: 0,
                left: 0,
                right: 0,
                // height: `${BANNER_HEIGHT}px`,
                zIndex: 999,
                backgroundColor: "#fef3c7",
                borderBottom: "1px solid #f59e0b",
                padding: "10px 20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <WarningOutlined style={{ color: "#d97706", fontSize: "18px" }} />
            <span style={{ color: "#92400e", fontWeight: 500 }}>
                {t('You have reached your plan limit for spaces (')}{currentSpacesCount}/{spacesLimit}).
                Please delete unused spaces or upgrade your plan.
            </span>
        </div>
    );
};

export default PlanLimitBanner;
